
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import DetailProduct from './DetailProduct';

function Index({dishs, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [dataFood, setDataFood] = useState(false);
    const [dataWok, setDataWok] = useState(false);
    const [dataappetizers, setdataappetizers] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false); 
    const [grill, setGrill] = useState(false);
    const [chaufa, setchaufa] = useState(false);
    const [ribeye, setRibeye] = useState(false);
    const [tacutu, settacutu] = useState(false);
    const [pastas, setpastas] = useState(false);
    const [tallarines, settallarines] = useState(false);
    const [brunch, setbrunch] = useState(false);


    const [summer, setsummer] = useState(false);

    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);
    

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 257) {
                setDataFood(item.menus);
            }

            if (item.id === 252) {
                setdataappetizers(item.menus);
            }

            if (item.id === 255) {
                setDataWok(item.menus);
            }

             if (item.id === 256) {
                setpastas(item.menus);
             }
             if (item.id === 632) {
                setbrunch(item.menus);
             }
            
            
        });
    }, [menus]);


     useEffect(() => {
        if (dataappetizers) {
            dataappetizers.map((item) => {
                if (item.id === 4985) {
                    setsummer(item);
                }
            });
        }
     }, [dataappetizers]);
    
    
    useEffect(() => {
        if (brunch) {
            brunch.map((item) => {
                if (item.id === 5468) {
                    settacutu(item);
                }
            });
        }
    }, [brunch]);

    useEffect(() => {
        if (dataWok) {
            dataWok.map((item) => {
                if (item.id === 5200) {
                    setchaufa(item);
                }
            });
        }
    }, [dataWok]);

    useEffect(() => {
        if (pastas) {
            pastas.map((item) => {
                if (item.id === 5469) {
                    settallarines(item);
                }
            });
        }
    }, [pastas]);

    useEffect(() => {
        if (dataFood) {
            dataFood.map((item) => {
                if (item.id === 5197) {
                    setGrill(item);
                }
                if (item.id === 2385) {
                    setRibeye(item);
                }

                if (item.id === 6885) {
                    setsummer(item);
                }

            });
        }
    }, [dataFood]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setShowListProduct} goHome={setShowHappy}>
                <div style={{ padding: '0 20px' }}>
                    

                    <div
                        onClick={() => {
                            setShowDetailProduct(true);
                            setDataDish({ dish: tallarines, alldish: [], currentDish: tallarines })
                        }}>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/tallarines.png')}
                            style={{
                                marginTop: 10,
                                width: '100%',
                                pointerEvents: 'none',
                                height: 180,
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />
                    </div>

                    <div
                        onClick={() => {
                            setShowDetailProduct(true);
                            setDataDish({ dish: tacutu, alldish: [], currentDish: tacutu })
                        }}>
                        <img
                            onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/banner11.png')}
                            style={{
                                marginTop: 10,
                                width: '100%',
                                height: 180,
                                 pointerEvents: 'none',
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />
                    </div>

                    <div
                        onClick={() => {
                            setShowDetailProduct(true);
                            setDataDish({ dish: summer, alldish: [], currentDish: summer })
                        }}>
                        <img
                            onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/summer.png')}
                            style={{
                                marginTop: 10,
                                width: '100%',
                                height: 180,
                                pointerEvents: 'none',
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />
                    </div>

                    
                    <div
                        onClick={() => {
                            setShowDetailProduct(true);
                            setDataDish({ dish: chaufa, alldish: [], currentDish: chaufa })
                        }}>
                        <img
                            onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/chaufa.png')}
                            style={{
                                marginTop: 10,
                                width: '100%',
                                height: 180,
                                 pointerEvents: 'none',
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />
                    </div>
                    
                    {/* <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between',
                            padding: '0 20px'
                        }}>
                        <img
                            src={require('./assets/banner4.png')}
                            style={{
                                width: 300,
                                height: 270,
                                objectFit: 'cover',
                                borderRadius: 13,
                            }}
                        />
                        <img
                            src={require('./assets/ashsdf.jpg')}
                            style={{
                                width: 300,
                                height: 270,
                                objectFit: 'cover',
                                borderRadius: 13,
                            }}
                        />
                    </div> */}
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}
            </LayoutContent>
        </div>
    );
}
export default Index;